module.exports = __webpack_public_path__ + "img/trunk_9x3_z16.042b51cd.svg";